import { Component, OnInit } from '@angular/core';
import { StorageService } from '../../../services/storage.service';
import { AuthUser } from '../../../shared/interface';

@Component({
  selector: 'app-home-backoffice',
  templateUrl: './home-backoffice.component.html',
  styleUrl: './home-backoffice.component.css'
})
export class HomeBackofficeComponent implements OnInit {

  constructor(private storageService: StorageService) { }

  user?: AuthUser | null;

  ngOnInit(): void {
    this.user = this.storageService.getUser();  
  }
}
